module.exports = __webpack_public_path__ + "img/picture12.422bc79e.png";